import React from 'react';
import Typography from '@mui/material/Typography';
import useGetSizeCrustDetails from './hooks/useGetSizeCrustDetails';
import { TProductDetails } from '@/common/ProductDetails/types';
import formattedPrice from '@/common/formattedPrice';

const ProductDetails = ({ price, product, isCyo }: TProductDetails): JSX.Element => {
  const sizeCrustSelections = useGetSizeCrustDetails(!isCyo, product);
  return (
    <>
      <Typography data-testid="product-details-size">
        {sizeCrustSelections}
      </Typography>
      <Typography data-testid="product-details-price">
        {isCyo && 'Large starting at '}
        {formattedPrice(price)}
      </Typography>
    </>
  );
};

export default ProductDetails;
